import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const IcsRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.ics"
        components={{
          mail: (
            <a href={`mailto: kpetrie@icscourier.ca`} className="email_space">
              kpetrie@icscourier.ca
            </a>
          ),
        }}
      />
    </div>
  );
};

export default IcsRequirements;
